import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Table from "../../../Components/Table";
import LeiaMais from "../../../Components/Utils/LeiaMais";
import {
    DeleteTemplateTwillioController,
    ListarTemplateTwilioController,
    RemoverTemplateMensagemAtivaController,
} from "../../../Controllers/HelpDesk/GestaoTemplate/GestaoTemplateController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IMensagemTemplate } from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import {
    ListarIntegracaoWpp,
    ListarMensagensTemplate,
} from "../../../Services/HelpDesk/GestaoAtendimentos/GestaoAtendimentosService";
import { ACESSOS } from "../../../Routes/Acessos";
import { useAtedimento } from "../../../Context/Atendimento";
import {
    ITwillioCallToActionType,
    ITwillioCardType,
    ITwillioListPickerType,
    ITwillioMediaType,
    ITwillioQuickReplyType,
    ITwillioTextType,
    ITwillioWhatsAppAuthenticationType,
    ITwillioWhatsAppCardType,
    Template,
} from "../../../Interfaces/HelpDesk/GestaoTemplate/GestaoTemplateInterace";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import { GetIntegracoesPorIdController } from "../../../Controllers/Geral/Integracao/IntegracoesController";

export default function GestaoTemplateHelpdesk() {
    const { HELP_DESK } = useAtedimento();

    const statusTranslations: { [key: string]: string } = {
        approved: "Aprovado",
        pending: "Pendente",
        rejected: "Rejeitado",
        unsubmitted: "Não enviado",
    };

    const getStatusTranslation = (status: string): string => {
        return statusTranslations[status] || status;
    };

    const { value: lstIntegracaoWpp, loading: lstIntegracaoWppLoading } =
        useAsyncEffect(async () => {
            if (HELP_DESK.equipe.NR_TELEFONE)
                return ListarIntegracaoWpp(
                    encodeURIComponent(HELP_DESK.equipe.NR_TELEFONE)
                );
        }, [HELP_DESK.equipe.NR_TELEFONE]);

    const {
        value: lstMensagensTemplate,
        loading: lstMensagensTemplateLoading,
        execute: updateList,
    } = useAsyncEffect(() => ListarMensagensTemplate());

    const {
        value: ListarTemplateTwilio,
        loading: ListarTemplateTwilioLoading,
        execute: updateListTemplateTwilio,
    } = useAsyncEffect(async () => {
        if (
            lstIntegracaoWpp &&
            lstIntegracaoWpp.data.DS_TIPO_INTEGRACAO.toUpperCase() === "TWILIO"
        ) {
            return ListarTemplateTwilioController();
        }
    }, [lstIntegracaoWpp]);

    const { value: getIntegracoesPorId } = useAsyncEffect(async () => {
        if (
            lstIntegracaoWpp?.data.DS_TIPO_INTEGRACAO.toUpperCase() === "TWILIO"
        ) {
            return GetIntegracoesPorIdController(
                lstIntegracaoWpp?.data.ID_TIPO_INTEGRACAO
            );
        }
    }, [lstIntegracaoWpp]);

    const getBodyContent = (types: Template["types"]) => {
        if (!types) return "";
        if ("twilio/text" in types)
            return (types as ITwillioTextType)["twilio/text"].body;
        if ("twilio/media" in types)
            return (types as ITwillioMediaType)["twilio/media"].body;
        if ("twilio/quick-reply" in types)
            return (types as ITwillioQuickReplyType)["twilio/quick-reply"].body;
        if ("twilio/call-to-action" in types)
            return (types as ITwillioCallToActionType)["twilio/call-to-action"]
                .body;
        if ("twilio/list-picker" in types)
            return (types as ITwillioListPickerType)["twilio/list-picker"].body;
        if ("twilio/card" in types)
            return (types as ITwillioCardType)["twilio/card"].title;
        if ("whatsapp/card" in types)
            return (types as ITwillioWhatsAppCardType)["whatsapp/card"].body;
        if ("whatsapp/authentication" in types)
            return (types as ITwillioWhatsAppAuthenticationType)[
                "whatsapp/authentication"
            ].add_security_recommendation.toString();
        return "";
    };

    const {
        execute: DeleteTemplateTwillio,
        loading: DeleteTemplateTwillioLoading,
    } = useAsyncCallback(DeleteTemplateTwillioController);

    function RowTableTwilio(cell: any, row: Template) {
        const bodyContent = getBodyContent(row.types);

        return (
            <div className="rowCapys">
                <div className="py-3">
                    <h2>{row.friendly_name ?? ""}</h2>
                    <span className="font-weight-bolder">
                        Body: <LeiaMais charLimit={100}>{bodyContent}</LeiaMais>
                    </span>
                    <div className="d-flex py-1">
                        <h6 className="font-weight-bolder mr-1">Status:</h6>
                        <span>
                            {getStatusTranslation(row.approval_requests.status)}
                        </span>
                    </div>
                </div>

                <div className="d-flex align-items-center flex-row">
                    <div className="Button-Tools pt-3">
                        <button
                            className="btn btn-outline-danger font-weight-bold mr-2"
                            type="button"
                            onClick={() => {
                                Swal.fire({
                                    title: `Deseja apagar o ${row.friendly_name}?`,
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Sim!",
                                    showCancelButton: true,
                                    cancelButtonText:
                                        "<i class='la la-thumbs-down'></i> Não",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                        cancelButton: "btn btn-default",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        DeleteTemplateTwillio(row.sid).then(
                                            () => {
                                                updateListTemplateTwilio();
                                            }
                                        );
                                    }
                                });
                            }}
                        >
                            {DeleteTemplateTwillioLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faTrash} size="lg" />
                            )}{" "}
                            Excluir
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const columnTwilio = [
        {
            dataField: "sid",
            text: "Descrição",
            formatter: RowTableTwilio,
            sort: true,
        },
    ];

    function RowTable(cell: any, row: IMensagemTemplate) {
        return (
            <>
                <div className="rowCapys">
                    <div className="py-3">
                        <h2>{row.DS_NOME_TEMPLATE ?? ""}</h2>
                        <span className="font-weight-bolder">
                            <LeiaMais charLimit={100}>
                                {row.DS_CORPO_TEMPLATE}
                            </LeiaMais>
                        </span>
                    </div>
                    <div className="d-flex flex-row">
                        <div className="Button-Tools pt-3">
                            <Link
                                to={`/HelpDesk/GestaoTemplates/ConfigurarTemplates/${row.ID_DOCUMENTO_TEMPLATE}`}
                                className="btn btn-outline-primary font-weight-bold mr-2"
                            >
                                <FontAwesomeIcon icon={faEdit} size="lg" />{" "}
                                Editar
                            </Link>
                        </div>
                        <div className="Button-Tools pt-3">
                            <button
                                className="btn btn-outline-danger font-weight-bold mr-2"
                                type="button"
                                onClick={() => {
                                    Swal.fire({
                                        title: `Deseja apagar o ${row.DS_NOME_TEMPLATE}?`,
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result) {
                                            RemoverTemplateMensagemAtivaController(
                                                row.ID_DOCUMENTO_TEMPLATE
                                            ).then(() => {
                                                updateList();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />{" "}
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const column = [
        {
            dataField: "DS_NOME_TEMPLATE",
            text: "Descrição",
            formatter: RowTable,
            sort: true,
        },
    ];

    return (
        <OrSpinner
            loading={
                lstIntegracaoWppLoading ||
                lstMensagensTemplateLoading ||
                ListarTemplateTwilioLoading
            }
            spinner="capys"
        >
            <div className="card card-custom">
                <div className="card-header card-header-tabs-line d-flex align-items-center">
                    <h3 className="card-title align-items-start ">
                        <span className="card-label font-weight-bolder text-dark gruposTitle">
                            Gestão de Templates
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <Link
                            to={
                                lstIntegracaoWpp?.data.DS_TIPO_INTEGRACAO ===
                                    "TWILIO" && getIntegracoesPorId
                                    ? ACESSOS.HELPDESK.TELAS
                                          .GESTAO_TEMPLATES_TWILIO.DS_PATH
                                    : `/HelpDesk/GestaoTemplates/ConfigurarTemplates/0`
                            }
                            className="btn btn-success font-weight-bold mr-2 linkSemIcone"
                        >
                            <FontAwesomeIcon icon={faPlus} className="mr-2" />
                            Cadastrar Template
                        </Link>
                    </div>
                </div>
                {lstIntegracaoWpp?.data.DS_TIPO_INTEGRACAO.toUpperCase() ===
                    "TWILIO" && getIntegracoesPorId ? (
                    <div className="card-body">
                        <Table
                            data={ListarTemplateTwilio?.Contents ?? []}
                            loading={ListarTemplateTwilioLoading}
                            bordered={false}
                            striped
                            columns={columnTwilio}
                            keyField="sid"
                            center
                            noSearch
                        />
                    </div>
                ) : (
                    <div className="card-body">
                        <Table
                            data={lstMensagensTemplate?.data ?? []}
                            loading={lstMensagensTemplateLoading}
                            bordered={false}
                            striped
                            columns={column}
                            keyField="ID_DOCUMENTO_TEMPLATE"
                            center
                            noSearch
                        />
                    </div>
                )}
            </div>
        </OrSpinner>
    );
}
